module.exports = __webpack_public_path__ + "static/media/qrcode3.0f60fd48.png";